function getNumberFromString(value)
{
  let num=(value.replace(/[^0-9]/g,''))
  return num!==undefined&& !Number.isNaN(num)?num:''
}
export default getNumberFromString